import { TimeTradingEnum } from '../SalariedDirectorFields/types';

export const SoleTraderFieldsQuestions = {
  timeTrading: {
    titleKey: 'affordabilityCalculator.soleTrader.timeTrading.title',
    textKey: 'affordabilityCalculator.soleTrader.timeTrading.text',
    options: [
      {
        labelKey: 'affordabilityCalculator.soleTrader.timeTrading.lessTime',
        value: TimeTradingEnum.lessThanTwoYears,
      },
      {
        labelKey: 'affordabilityCalculator.soleTrader.timeTrading.moreTime',
        value: TimeTradingEnum.moreThanTwoYears,
      },
    ],
  },
  netTaxableIncomeRecentYear: {
    titleKey: 'affordabilityCalculator.soleTrader.netTaxableIncomeRecentYear.title',
  },
  netTaxableIncomePreviousYear: {
    titleKey: 'affordabilityCalculator.soleTrader.netTaxableIncomePreviousYear.title',
  },
  error: {
    required: 'common.error.requiredField',
  },
};
